var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DialogTemplate",
    {
      staticClass: "DialogTemplateArea",
      attrs: { "is-open": _vm.isOpen },
      on: { "click-mask": _vm.onClickMask },
    },
    [
      _c(
        "div",
        {
          staticClass: "confirmContent",
          class: { isPc: !_vm.isSp, wideContentsWidth: _vm.wideContentsWidth },
        },
        [
          _c("div", {
            staticClass: "text",
            class: [_vm.fontSize, { isPc: !_vm.isSp, fontBold: _vm.fontBold }],
            domProps: { textContent: _vm._s(_vm.text) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "choicesArea", class: { isPc: !_vm.isSp } },
            [
              _c("ButtonTypeCustom", {
                staticClass: "negativeButton",
                attrs: {
                  "button-type": "button",
                  "button-text": _vm.negativeCustomText,
                  "button-color": "colorCancel",
                  "button-size": "sizeLarge",
                },
                on: { "button-clicked": _vm.onClickNegative },
              }),
              _vm._v(" "),
              _c("ButtonTypeCustom", {
                attrs: {
                  "button-type": "button",
                  "button-text": _vm.positiveCustomText,
                  "button-color": "colorPrimary",
                  "button-size": "sizeLarge",
                },
                on: { "button-clicked": _vm.onClickPositive },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }